<template>
  <el-button :size="size" :type="type" :icon="icon" @click="openPDF" :disabled="disabled" :loading="isLoading">
    <slot></slot>
  </el-button>
</template>

<script>
import b64toBlob from 'b64-to-blob';

export default {
  props: {
    type: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    payload: {
      type: [Object, String],
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      base64Data: null,
      isLoading: false,
      src: null,
    };
  },
  methods: {
    fetchPDF() {
      Promise.error('This method needs to implemented by a component that extends the base component');
    },
    openPDF() {
      this.isLoading = true;
      this.fetchPDF(this.payload).then((result) => {
        const filename = result.filename;
        const data = result.content;
        const blob = b64toBlob(data, result.contentType);
        if (this.isIE) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const anchor = document.createElement('a');
          anchor.setAttribute('download', filename);
          anchor.setAttribute('href', URL.createObjectURL(blob));
          anchor.setAttribute('style', 'display: none;');
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
        }
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Could not create PDF',
          position: 'bottom-right',
        });
      }).finally(() => {
        this.isLoading = false;
      });
    },
  },
  computed: {
    isIE() {
      return window && window.navigator && window.navigator.msSaveOrOpenBlob;
    },
  },
};

</script>
